<script setup lang="ts">
import {onLaunch, onShow, onHide} from "@dcloudio/uni-app";
import {postLoginByWxCode} from "@/services/login";
import {loginSuccess, switchTab} from "@/utils/loginUtil";
import {useAuthStore, useMemberStore} from "@/stores";


const globalData = {
  openId: '',
  state: '/',
  login: false,
}

onLaunch(async (options) => {

  const query = options?.query
  const path = options?.path
  uni.hideTabBar()
  //options.query.cid && uni.setStorageSync('cid', options.query.cid)
  try {
    if (query?.cid) {
      //getApp().globalData.clientId = options.query.cid
      uni.setStorageSync('clientId', query.cid);
    }
  } catch (e) {
    console.error(e);
  }

  if (query?.token) {
    uni.setStorageSync('tt', 1);
    await useAuthStore().setToken(query.token)
    await useMemberStore().setUserLevel()
  } else if (query?.tt) {
    uni.removeStorageSync('tt');
  }


  if (query?.code && path !== 'pagesOrder/detail/detail') {
    const result = await postLoginByWxCode({code: query.code, channel: 'APP'})
    const targetUrl = path === 'pages/login/login' ? query?.state ? decodeURIComponent(query.state) : '/' : null
    //console.log(targetUrl, options)

    if (result.code === 1102) {
      const __globalData = getApp().globalData
      if (__globalData) {
        __globalData.state = targetUrl
      }

    } else if (result.code === 1010) {
      const __globalData = getApp().globalData
      if (__globalData) {
        __globalData.openId = result.message
        __globalData.state = targetUrl
      }
    } else if (result.code === 0) {
      const __globalData = getApp().globalData
      if (__globalData) {
        __globalData.login = true
      }

      loginSuccess({token: result.data.token, url: targetUrl})
    }
  }
})

onShow((options) => {
  uni.hideTabBar()
  const path = options?.path
  const __globalData = getApp().globalData
  //console.log(getApp(),options)
  if (path === 'pages/login/login' && __globalData?.login === true) {
    __globalData.login = false
    switchTab(__globalData?.state)
  }
})

onHide(() => {
  console.log('App Hide')
})
</script>

<style>
/*每个页面公共css */
</style>
